import { ChartLineUp } from "@phosphor-icons/react";
import {
  ResponsiveContainer,
  BarChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Cell,
  Legend,
  ReferenceLine,
} from "recharts";

const TICK_DARK = { fontSize: 11, fill: "#6b7280" };
const TICK_LIGHT = { fontSize: 11, fill: "#9ca3af" };
const TOOLTIP_DARK = { background: "#12121a", border: "1px solid rgba(255,255,255,0.1)", borderRadius: "8px", fontSize: "12px", color: "#fff" };
const TOOLTIP_LIGHT = { background: "white", border: "1px solid #e5e7eb", borderRadius: "8px", fontSize: "12px", color: "#111" };
const BAR_RADIUS_TOP = [4, 4, 0, 0];
const TOOLTIP_FMT = (v) => [`${v.toFixed(1)}%`];
const Y_TICK_FMT = (v) => `${v}%`;

export function PerformanceChart({ chartData, isDark }) {
  if (!chartData || chartData.length === 0) return null;

  const tickStyle = isDark ? TICK_DARK : TICK_LIGHT;
  const tooltipStyle = isDark ? TOOLTIP_DARK : TOOLTIP_LIGHT;
  const gridStroke = isDark ? "#1f1f2e" : "#e2e8f0";
  const axisStroke = isDark ? "#374151" : "#94a3b8";

  return (
    <div className={`rounded-xl p-6 border ${isDark ? "bg-[#12121a] border-white/10" : "bg-white border-gray-200"}`} data-testid="perf-chart">
      <h3 className={`font-bold mb-4 flex items-center gap-2 ${isDark ? "text-white" : "text-gray-900"}`}>
        <ChartLineUp size={20} className="text-purple-500" />
        Predicted vs Actual ROI
      </h3>
      <div className="h-64">
        <ResponsiveContainer width="100%" height="100%">
          <BarChart data={chartData}>
            <CartesianGrid strokeDasharray="3 3" stroke={gridStroke} />
            <XAxis dataKey="name" tick={tickStyle} stroke={axisStroke} />
            <YAxis tick={tickStyle} stroke={axisStroke} tickFormatter={Y_TICK_FMT} />
            <Tooltip contentStyle={tooltipStyle} formatter={TOOLTIP_FMT} />
            <Legend />
            <ReferenceLine y={0} stroke={axisStroke} />
            <Bar dataKey="predicted" name="Predicted ROI" fill="#a855f7" radius={BAR_RADIUS_TOP} />
            <Bar dataKey="actual" name="Actual ROI" radius={BAR_RADIUS_TOP}>
              {chartData.map((entry) => (
                <Cell key={entry.name} fill={entry.actual >= 0 ? "#10b981" : "#ef4444"} />
              ))}
            </Bar>
          </BarChart>
        </ResponsiveContainer>
      </div>
    </div>
  );
}
